"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleContainer = exports.Title = exports.Subtitle = exports.ScrollExperienceContainer = exports.Overlay = exports.ImageWrapper = exports.Image = exports.Headline = exports.ContainerDiv = exports.BackgroundImage = exports.AggregatorWrapper = exports.AggregatorTitle = exports.AggregatorSubtitle = exports.AggregatorLink = exports.AggregatorInfo = exports.AggregatorContent = exports.AggregatorCTA = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ContainerDiv = _styledComponents.default.div`
  padding: 0px 16px;

  @media (min-width: 768px) {
    display: flex;
    flex-wrap: nowrap;
    height: 100%;
    align-items: center;
    padding: 0px;
  }
`;
exports.ContainerDiv = ContainerDiv;
const Headline = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  & > * {
    width: 100%;
  }

  @media (min-width: 1024px) {
    width: 100vw;
    flex-direction: row;
    & > * {
      width: 50%;
      padding: 10px 15px;
    }
  }
`;
exports.Headline = Headline;
const TitleContainer = _styledComponents.default.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;
exports.TitleContainer = TitleContainer;
const Title = _styledComponents.default.h2`
  text-transform: uppercase;
  font-family: 'univers-black', sans-serif;
  font-size: 50px;
  line-height: 90%;
  letter-spacing: -0.01em;
  font-style: normal;
  font-weight: 900;

  margin: 25px 0 0;

  @media (min-width: 1024px) {
    font-size: 90px;
  }
`;
exports.Title = Title;
const Subtitle = _styledComponents.default.p`
  font-family: 'univers-roman', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 90%;
  letter-spacing: -0.01em;
  text-transform: uppercase;

  @media (min-width: 1024px) {
    font-size: 29px;
  }
`;
exports.Subtitle = Subtitle;
const ScrollExperienceContainer = _styledComponents.default.div`
  opacity: 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  div {
    width: 50%;
    span {
      font-family: 'univers-roman', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
      line-height: 90%;

      letter-spacing: -0.01em;
      text-transform: uppercase;
    }
  }
  @media (min-width: 1024px) {
    opacity: 1;
  }
`;
exports.ScrollExperienceContainer = ScrollExperienceContainer;
const ImageWrapper = _styledComponents.default.div`
  max-width: 100%;
  @media (min-width: 768px) {
    padding: 0px 13px;
    width: ${props => `calc(${100 * props.aspectRatio}vh - ${170 * props.aspectRatio}px);`};
  }
`;
exports.ImageWrapper = ImageWrapper;
const Image = _styledComponents.default.img`
  max-width: 100%;

  @media (min-width: 768px) {
    height: calc(90vh - 90px);
  }
`;
exports.Image = Image;
const AggregatorWrapper = _styledComponents.default.div`
  width: 100%;
  max-width: 100%;
  margin: 16px 0px;
  min-height: ${props => {
  return `calc(${100 / props.aspectRatio}vw - ${40 / props.aspectRatio}px);`;
}};
  overflow: hidden;
  position: relative;

  @media (min-width: 768px) {
    margin: 0px 16px;
    min-height: calc(100vh - 170px);
    min-width: ${props => {
  return `calc(${100 * props.aspectRatio}vh - ${170 * props.aspectRatio}px);`;
}};
  }
`;
exports.AggregatorWrapper = AggregatorWrapper;
const AggregatorContent = _styledComponents.default.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  color: white;

  &:hover {
    .aa-overlay {
      opacity: 0.65;
    }
  }
`;
exports.AggregatorContent = AggregatorContent;
const BackgroundImage = _styledComponents.default.div`
  position: absolute;
  top: 50%;
  left: 50%;
  border: 1px solid transparent;
  background-image: url('${props => props.image}');
  background-color: blue;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  transition: 0.35s all;
  transform-origin: center center;
  transform: translate3d(-50%, -50%, 0);
  //transform-origin: center center;
`;
exports.BackgroundImage = BackgroundImage;
const AggregatorInfo = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  height: 100%;
  color: white;
  padding: 40px 32px;
  position: relative;
  z-index: 1;

  @media (min-width: 768px) {
    padding: 60px 40px;
  }
`;
exports.AggregatorInfo = AggregatorInfo;
const AggregatorTitle = _styledComponents.default.h4`
  font-style: normal;
  line-height: 1em;
  letter-spacing: -0.01em;
  text-transform: uppercase;

  max-width: 75%;
  margin: 0 0 16px;

  ${(0, _typography.setFont)({
  headline: true
})}
  ${(0, _typography.setFontSizes)({
  xs: '24px',
  sm: '36px',
  xl: '48px'
})}

  @media (min-width: 992px) {
    min-height: ${props => props.minHeight}px;
    max-width: 70%;
  }
`;
exports.AggregatorTitle = AggregatorTitle;
const AggregatorSubtitle = _styledComponents.default.p`
  font-style: normal;
  line-height: 110%;
  margin: 0px 0px 32px 0px;

  ${(0, _typography.setFont)({
  r: true
})}
  ${(0, _typography.setFontSizes)({
  xs: '16px',
  sm: '20px'
})}
  text-transform: uppercase;
  letter-spacing: -0.01em;

  @media (min-width: 768px) {
    max-width: 70%;
  }
`;
exports.AggregatorSubtitle = AggregatorSubtitle;
const Overlay = _styledComponents.default.div`
  position: absolute;
  left: 0;
  bottom: 0;
  height: 85%;
  width: 104%;
  transition: 0.35s opacity;
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.55) 0%,
    rgba(0, 0, 0, 0) 100%
  );

  @media (min-width: 768px) {
    height: 65%;
  }
`;
exports.Overlay = Overlay;
const AggregatorCTA = _styledComponents.default.div`
  border: 1px solid;
  transition: 0.25s all;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
    padding: 0px 30px;
  }

  p {
    font-family: 'univers-black', sans-serif;
    font-style: normal;
    font-weight: 900;
    line-height: 110%;
    transition: 0.25s all;
    text-transform: uppercase;
    margin: 0px;
    ${(0, _typography.setFont)({
  headline: true
})}
    ${(0, _typography.setFontSizes)({
  xs: '14px'
})}
  }

  &:hover {
    background-color: white;
    p {
      color: black;
    }
  }
`;
exports.AggregatorCTA = AggregatorCTA;
const AggregatorLink = _styledComponents.default.a`
  text-decoration: none;
  color: white;
  position: relative;
  width: 100%;
`;
exports.AggregatorLink = AggregatorLink;
//# sourceMappingURL=aggregatorStyles.js.map